import loadable from '@loadable/component';
export const LoginPage=loadable(() => import('./LoginPage'));
